const Vacancy = {
  init() {
    Vacancy.dropzone.init();
  },

  dropzone: {
    dt: new DataTransfer(),

    init: function () {
      this.events();
    },

    events: function () {
      var _self = this;
      var dz = $(".dropzone");
      var fileInput = dz.children("#files");
      var dropContainer = dz;

      dropContainer
        .on("dragover", function (e) {
          e.preventDefault();
          e.stopPropagation();
        })
        .on("dragenter", function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropContainer.addClass("dragover");
        })
        .on("dragleave", function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropContainer.removeClass("dragover");
        })
        .on("drop", function (e) {
          e.preventDefault();
          e.stopPropagation();
          dropContainer.removeClass("dragover");

          if (
            e.originalEvent.dataTransfer &&
            e.originalEvent.dataTransfer.files[0]
          ) {
            var uploadedFiles = e.originalEvent.dataTransfer.files;
            _self.process(uploadedFiles);
          }
        });

      fileInput.on("change", function (e) {
        var dz = $(".dropzone");
        var fileInput = dz.children("#files");
        var currentFiles = fileInput.prop("files");
        var list = $(".form__file__list");
        // Accepted types.
        var accepted = fileInput.attr("accept");
        accepted = accepted.split(",");
        $.each(currentFiles, function (index, file) {
          if (accepted.includes(file.type)) {
            if (
              !$('[data-id="' + file.name + '"][data-size="' + file.size + '"]')
                .length
            ) {
              _self.dt.items.add(file);
              var cloned = $(".form__file--clone-base", list).clone();
              cloned
                .attr("data-id", file.name)
                .attr("data-size", file.size)
                .removeClass("form__file--clone-base");
              $(".form__file__name", cloned).text(file.name);
              cloned.addClass("done").appendTo(list);
            }
          } else {
            ContactForm.messageOpen(translations.valid_file_types, "error");
          }
        });
        fileInput.prop("files", _self.dt.files);
      });

      $(".form__files").on("click", ".js-remove", function () {
        var that = $(this).closest(".form__file");
        var dz = $(".dropzone");
        var dt = new DataTransfer();
        var fileInput = dz.children("#files");
        // Current files.
        var currentFiles = fileInput.prop("files");
        $.each(currentFiles, function (index, file) {
          if (file.size != that.data("size") && file.name != that.data("id")) {
            dt.items.add(file);
          }
        });
        _self.dt = dt;
        fileInput.prop("files", dt.files);
        that.remove();
      });
    },

    process: function (uploadedFiles) {
      var _self = this;
      var dz = $(".dropzone");
      var fileInput = dz.children("#files");
      var message = dz.find(".dropzone__text");
      var dt = new DataTransfer();
      var list = $(".form__file__list");
      var uniqueFiles = [];
      // Accepted types.
      var accepted = fileInput.attr("accept");
      accepted = accepted.split(",");

      // Current files.
      var currentFiles = fileInput.prop("files");
      $.each(currentFiles, function (index, file) {
        dt.items.add(file);
        uniqueFiles.push(file.name + file.size);
      });

      $.each(uploadedFiles, function (index, file) {
        if (
          accepted.includes(file.type) &&
          !uniqueFiles.includes(file.name + file.size)
        ) {
          dt.items.add(file);

          if (
            !$('[data-id="' + file.name + '"][data-size="' + file.size + '"]')
              .length
          ) {
            var cloned = $(".form__file--clone-base", list).clone();
            cloned
              .attr("data-id", file.name)
              .attr("data-size", file.size)
              .removeClass("form__file--clone-base");
            $(".form__file__name", cloned).text(file.name);
            cloned.addClass("done").appendTo(list);
          }
        } else {
          ContactForm.messageOpen(translations.valid_file_types, "error");
        }
      });
      if (dt.items.length) {
        _self.dt = dt;
        fileInput.prop("files", dt.files);
      }
    },
  },
};

export default Vacancy;
